import * as React from "react";
import { Box, Stack, Typography, Paper } from "@mui/material";

// dummy obrazki (jak pisa�e�)
import { CMDHero, city, female_agent, worker, processes } from "../components/Images/images";

import RouterIcon from "@mui/icons-material/Router";
import CallIcon from "@mui/icons-material/Call";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import ExtensionIcon from "@mui/icons-material/Extension";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import ApiIcon from "@mui/icons-material/Api";
import ScheduleIcon from "@mui/icons-material/Schedule";
import SupportAgent from "@mui/icons-material/SupportAgent";

/**
 * Wzorzec: �Ready state� banner do g�ry tabeli.
 * - �ywszy (gradient + image)
 * - skondensowany (kr�tkie title + opis + hint)
 * - bez akcji (plusik masz osobno)
 */
function ReadyStateBanner({ icon, title, description, hint, imageSrc = CMDHero }) {
    return (
        <Paper
            elevation={0}
            sx={{
                position: "relative",
                borderRadius: 2,
                mb: 2,
                // �ywsze t�o, ale bez krzykliwo�ci
                background:
                    "linear-gradient(135deg, rgba(33,150,243,0.10) 0%, rgba(156,39,176,0.08) 45%, rgba(0,200,83,0.08) 100%)",
            }}
        >
            {/* obrazek po prawej */}
            <Box
                aria-hidden="true"
                sx={{
                    position: "absolute",
                    inset: 0,
                    display: { xs: "none", sm: "block" },
                    opacity: 0.18,
                    //backgroundImage: `url(${imageSrc})`,
                    //backgroundRepeat: "no-repeat",
                    //backgroundPosition: "left center",
                    //backgroundSize: " auto",
                    pointerEvents: "none",
                }}
            />

            <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                sx={{
                    p: { xs: 2, sm: 2.5 },
                    position: "relative",
                }}
            >
                <Box
                    sx={{
                        width: 44,
                        height: 44,
                        borderRadius: 2,
                        display: "grid",
                        placeItems: "center",
                        bgcolor: "rgba(255,255,255,0.55)",
                        backdropFilter: "blur(6px)",
                        border: "1px solid rgba(0,0,0,0.06)",
                        flex: "0 0 auto",
                    }}
                >
                    {icon}
                </Box>

                <Stack spacing={0.25} sx={{ minWidth: 0 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
                        {title}
                    </Typography>

                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                            lineHeight: 1.35,
                            maxWidth: 760,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}
                    >
                        {description}
                    </Typography>

                    {hint && (
                        <Typography
                            variant="caption"
                            sx={{
                                color: "text.secondary",
                                mt: 0.25,
                            }}
                        >
                            {hint}
                        </Typography>
                    )}
                </Stack>
            </Stack>
        </Paper>
    );
}

/* ---------------- Ready states (do g�ry tabeli) ---------------- */

export function WorkersReadyState() {
    return (
        <ReadyStateBanner
            imageSrc={worker}
            icon={<RouterIcon sx={{ fontSize: 22, color: "primary.main" }} />}
            title="Workers connected"
            description="Workers execute tasks for your agents including UI automation and local actions."
            hint="Tip: assign the right worker to the right workload (Windows VM vs Linux cloud worker)."
        />
    );
}

export function TelephonyReadyState() {
    return (
        <ReadyStateBanner
            imageSrc={city}
            icon={<CallIcon sx={{ fontSize: 22, color: "primary.main" }} />}
            title="Telephony ready"
            description="Telephony is enabled and agents can handle calls and trigger processes end-to-end."
            hint="You can assign telephone numbers in Agent Configuration"
        />
    );
}

export function ApiKeysReadyState() {
    return (
        <ReadyStateBanner
            imageSrc={CMDHero}
            icon={<VpnKeyIcon sx={{ fontSize: 22, color: "primary.main" }} />}
            title="API keys active"
            description="External systems can securely trigger actions and integrations using your keys."
            hint="Use separate keys per environment and rotate keys periodically."
        />
    );
}

export function ProcessesReadyState() {
    return (
        <ReadyStateBanner
            imageSrc={processes}
            icon={<AccountTreeIcon sx={{ fontSize: 22, color: "primary.main" }} />}
            title="Processes available"
            description="Your uploaded processes are ready to run manually, via scheduler, or through API endpoints."
            hint="Keep processes small and composable for easier reuse."
        />
    );
}

export function SkillsReadyState() {
    return (
        <ReadyStateBanner
            imageSrc={CMDHero}
            icon={<ExtensionIcon sx={{ fontSize: 22, color: "primary.main" }} />}
            title="Skills ready"
            description="Reusable skills are available for agents to execute actions across tools and systems."
            hint="Build skills once, reuse them across multiple agents."
        />
    );
}

export function JobsReadyState() {
    return (
        <ReadyStateBanner
            imageSrc={CMDHero}
            icon={<WorkHistoryIcon sx={{ fontSize: 22, color: "primary.main" }} />}
            title="Job executions"
            description="Track jobs triggered manually or by schedulers with inputs, status, and results in one place."
            hint="Use filters to quickly find failed or long-running jobs."
        />
    );
}

export function ApiEndpointsReadyState() {
    return (
        <ReadyStateBanner
            imageSrc={CMDHero}
            icon={<ApiIcon sx={{ fontSize: 22, color: "primary.main" }} />}
            title="API endpoints live"
            description="Endpoints are ready to trigger processes from external apps and integrations."
            hint="Standardize payload shapes to keep integrations stable."
        />
    );
}

export function SchedulersReadyState() {
    return (
        <ReadyStateBanner
            imageSrc={CMDHero}
            icon={<ScheduleIcon sx={{ fontSize: 22, color: "primary.main" }} />}
            title="Schedulers running"
            description="Recurring jobs are configured and will trigger processes automatically on schedule."
            hint="Review schedules after process updates to avoid unexpected runs."
        />
    );
}

export function AgentsReadyState() {
    return (
        <ReadyStateBanner
            imageSrc={female_agent}
            icon={<SupportAgent sx={{ fontSize: 22, color: "primary.main" }} />}
            title="Agents ready"
            description="Your agents can interact with users and execute skills and processes across your tools."
            hint="Assign clear roles to each agent (support, ops, back office) for best outcomes."
        />
    );
}
